export default __webpack_public_path__ + "static/media/img17_s.ffb3ae64.png";